import { createContext, useState } from "react";

export const DataProvider = createContext();

function ContextProvider({ children }) {
  const [isLoginDialogOpen, issetLoginDialogOpen] = useState(false);
  const [showotpcomponent, setshowotpcomponent] = useState(false);
  const [isSignup, setisSignup] = useState(false);
  const [contextdata, setContextdata] = useState({
    wishList: [],
  });

  return (
    <DataProvider.Provider
      value={{
        setContextdata,
        contextdata,
        isLoginDialogOpen,
        issetLoginDialogOpen,
        setisSignup,
        isSignup,
        setshowotpcomponent,
        showotpcomponent,
      }}
    >
      {children}
    </DataProvider.Provider>
  );
}

export default ContextProvider;
